import { render } from "./TicketShow.vue?vue&type=template&id=3b5f7328&scoped=true"
import script from "./TicketShow.vue?vue&type=script&lang=js"
export * from "./TicketShow.vue?vue&type=script&lang=js"

import "./TicketShow.vue?vue&type=style&index=0&id=3b5f7328&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5f7328"]])

export default __exports__